import $ from 'jquery';

export function ToolbarPanelDirective($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      title: '@'
    },
    link: function (scope, element, attrs) {
      $(element).attr('flex', '');
      $(element).find('.title').text(attrs.title);
    },
    transclude: true,
    template: '<div class="title"></div><div class="content" ng-transclude></div>'
  };
}



// WEBPACK FOOTER //
// ./client/components/canvas/toolbarPanel.directive.js